export default {
  path: "/HighlightedTopic/AutonomousVehicle",
  name: "Highlighted Topic - Fully Autonomous Vehicles",
  type: "highlightedTopic",
  htmlContent: "HT-AutnomousVehicle.html",
  keyPoints: [
    "All <u>Fully Autonomous Vehicles</u>, regardless of their design, will be treated as a Motor Vehicle, and if involved in any type of crash, a Georgia Uniform Motor Vehicle Accident Report (GUMVAR) will be used to document the event.",
  ],
  scenarios: [{
    name: 'Special Notes',
    description: `
        <ul>
            <li> If Ownership and Insurance information are not available, the robotic vehicle must be impounded.  </li>
            <li> OCGA 40-1-1 (43.1) “Personal delivery device” means a powered vehicle that utilizes an automated driving system to transport cargo, is not designed to transport passengers, and has a maximum unladen weight of 500 pounds…   Because the weight of these vehicles is not readily known, all PDD will be treated as a “Motor Vehicle” to simplify the reporting requirements.
            </li>
        </ul> 
        `,
  }],
  keywords: ['self-driving','self driving', 'AV', 'av'],
};
